export default {
  activeVersion: 'v2',
  baseUrl: 'https://shared.mediahuis.be/logos/nb/',
  alt: 'Nieuwsblad',
  v2: {
    main: {
      'brand-main': {
        png: 'brand-main.png',
        svg: 'brand-main.svg',
      },
      'brand-square-main': {
        png: 'brand-square-main.png',
        svg: 'brand-square-main.svg',
      },
      'brand-plus-main': {
        png: 'brand-plus-main.png',
        svg: 'brand-plus-main.svg',
        alt: 'Plus Artikel',
      },
    },
    // Not validated
    variations: {
      'brand-icon-name-vertical': {
        png: 'brand-icon-name-vertical.png',
        svg: 'brand-icon-name-vertical.svg',
      },
      'brand-icon': {
        png: 'brand-icon.png',
        svg: 'brand-icon.svg',
      },
      'brand-name-white': {
        png: 'brand-name-white.png',
        svg: 'brand-name-white.svg',
      },
      'brand-name': {
        png: 'brand-name.png',
        svg: 'brand-name.svg',
      },
      'brand-icon-newspaper': {
        png: 'brand-icon-newspaper.png',
        svg: 'brand-icon-newspaper.svg',
      },
      'brand-rectangle-icon-name-horizontal-white': {
        png: 'brand-rectangle-icon-name-horizontal-white.png',
        svg: 'brand-rectangle-icon-name-horizontal-white.svg',
      },
      'brand-rectangle-icon-name-horizontal': {
        png: 'brand-rectangle-icon-name-horizontal.png',
        svg: 'brand-rectangle-icon-name-horizontal.svg',
      },
      'brand-square-icon-name-vertical': {
        png: 'brand-square-icon-name-vertical.png',
        svg: 'brand-square-icon-name-vertical.svg',
      },
      'brand-square-icon': {
        png: 'brand-square-icon.png',
        svg: 'brand-square-icon.svg',
      },
    },
    subscriptions: {
      'abo-digitaal': {
        png: 'abo-digitaal.png',
        svg: 'abo-digitaal.svg',
        alt: 'Abonnement Digitaal',
      },
      'abo-slim': {
        png: 'abo-slim.png',
        svg: 'abo-slim.svg',
        alt: 'Abonnement Slim',
      },
      'abo-snel': {
        png: 'abo-snel.png',
        svg: 'abo-snel.svg',
        alt: 'Abonnement Snel',
      },
      'abo-super': {
        png: 'abo-super.png',
        svg: 'abo-super.svg',
        alt: 'Abonnement Super',
      },
      'plus-basic': {
        png: 'plus-basic.png',
        svg: 'plus-basic.svg',
        alt: 'Plus basic',
      },
      'plus-brand-square-dg': {
        png: 'plus-brand-square-dg.png',
        svg: 'plus-brand-square-dg.svg',
        alt: '',
      },
      'plus-brand-square-ds': {
        png: 'plus-brand-square-ds.png',
        svg: 'plus-brand-square-ds.svg',
        alt: '',
      },
      'plus-brand-square-gva': {
        png: 'plus-brand-square-gva.png',
        svg: 'plus-brand-square-gva.svg',
        alt: '',
      },
      'plus-brand-square-hbvl': {
        png: 'plus-brand-square-hbvl.png',
        svg: 'plus-brand-square-hbvl.svg',
        alt: '',
      },
      'plus-brand-square-nb': {
        png: 'plus-brand-square-nb.png',
        svg: 'plus-brand-square-nb.svg',
        alt: '',
      },
      'plus-digi': {
        png: 'plus-digi.png',
        svg: 'plus-digi.svg',
        alt: 'Plus digi',
      },
      'plus-full': {
        png: 'plus-full.png',
        svg: 'plus-full.svg',
        alt: 'Plus full',
      },
      'plus-icon-inverse': {
        png: 'plus-icon-inverse.png',
        svg: 'plus-icon-inverse.svg',
        alt: 'plus',
      },
      'plus-icon-name-inverse': {
        png: 'plus-icon-name-inverse.png',
        svg: 'plus-icon-name-inverse.svg',
        alt: 'plus',
      },
      'plus-icon-name': {
        png: 'plus-icon-name.png',
        svg: 'plus-icon-name.svg',
        alt: 'plus',
      },
      'plus-icon': {
        png: 'plus-icon.png',
        svg: 'plus-icon.svg',
        alt: 'plus',
      },
      'plus-wknd': {
        png: 'plus-wknd.png',
        svg: 'plus-wknd.svg',
        alt: 'Plus wknd',
      },
    },
  },
};
